import { getSessionData } from "./function";
import { readMandateSession } from "./mandateSessionStorage";

/** Match current clinic id against mandate `clinicBranches`. */
export const getMatchedClinicBranch = () => {
  try {
    const session = readMandateSession() ?? {};
    const clinic = session?.clinic ?? getSessionData()?.clinic ?? {};
    const branches = Array.isArray(session?.clinicBranches)
      ? session.clinicBranches
      : [];

    let profile = {};
    try {
      profile = JSON.parse(localStorage.getItem("user") || "{}");
    } catch {
      profile = {};
    }

    const clinicId =
      clinic?.id ??
      profile?.activeBranchId ??
      profile?.id ??
      localStorage.getItem("hospitalId") ??
      null;

    if (clinicId == null || clinicId === "") return null;

    return branches.find((b) => String(b?.id) === String(clinicId)) ?? null;
  } catch {
    return null;
  }
};

const isBranchClinic = () => !!getMatchedClinicBranch()?.branchNumber;

/** Main clinic always allowed; branch needs `allowBranchStockEdit`. */
export const canCreateBranchStock = (dataSharing) => {
  const session = readMandateSession() ?? {};
  const sharing =
    dataSharing ?? session?.dataSharing ?? getSessionData()?.dataSharing ?? {};
  const clinic = session?.clinic ?? getSessionData()?.clinic ?? {};
  let user = {};
  try {
    user = JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    user = {};
  }
  const isMainClinic =
    !isBranchClinic() && String(user?.id) === String(clinic?.id);
  return isMainClinic || !!sharing?.allowBranchStockEdit;
};

/** Main clinic always allowed; branch needs `allowBranchServiceEdit`. */
export const canCreateBranchService = (dataSharing) => {
  const session = readMandateSession() ?? {};
  const sharing =
    dataSharing ?? session?.dataSharing ?? getSessionData()?.dataSharing ?? {};
  const clinic = session?.clinic ?? getSessionData()?.clinic ?? {};
  let user = {};
  try {
    user = JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    user = {};
  }
  const isMainClinic =
    !isBranchClinic() && String(user?.id) === String(clinic?.id);
  return isMainClinic || !!sharing?.allowBranchServiceEdit;
};

/** Lock master stock fields when branch cannot create/edit stock. */
export const isStockMasterFieldsLocked = (dataSharing) =>
  !canCreateBranchStock(dataSharing);

/** Lock master service fields when branch cannot create/edit services. */
export const isServiceMasterFieldsLocked = (dataSharing) =>
  !canCreateBranchService(dataSharing);
